import React from "react";

const AboutUsSection = () => {
  return (
    <>
      {/* About Us Section Start */}
      <section className="about-us-section fix section-padding pt-0 bg-color2">
        <div className="about-wrapper style2">

          <div className="shape1 d-none d-xxl-block">
            <img src="/assets/img/shape/aboutShape2_1.png" alt="shape" />
          </div>

          <div className="container">
            <div className="about-us section-padding">
              <div className="row d-flex align-items-center">

                {/* Left Content */}
                <div className="col-lg-6 d-flex align-items-center justify-content-center justify-content-xl-start">
                  <div className="about-thumb mb-5 mb-lg-0">
                    <img
                      src="/assets/img/about/about2.png"
                      alt="thumb"
                    />

                    <div className="video-wrap">
                      <a
                        href="https://www.youtube.com/shorts/HH39uo_zv7Q"
                        className="play-btn popup-video"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          className="cir36"
                          src="/assets/img/shape/player.svg"
                          alt="icon"
                        />
                      </a>
                    </div>
                  </div>
                </div>

                {/* Right Content */}
                <div className="col-lg-6">
                  <div className="title-area">

                    <div
                      className="sub-title text-start wow fadeInUp"
                      data-wow-delay="0.5s"
                    >
                      <img
                        className="me-1"
                        src="/assets/img/icon/titleIcon.svg"
                        alt="icon"
                      />
                      About US
                      <img
                        className="ms-1"
                        src="/assets/img/icon/titleIcon.svg"
                        alt="icon"
                      />
                    </div>

                    <h2
                      className="title text-start wow fadeInUp"
                      data-wow-delay="0.7s"
                    >
                     About The Spice Root
                    </h2>

                    <div
                      className="text text-start wow fadeInUp"
                      data-wow-delay="0.8s"
                    >
                     The Spice Root is a trusted premium catering and events service based in Ahmedabad, known
                      for delivering exceptional taste and professional service.
                    With 15+ years of experience, we specialize in catering for weddings, baby showers,
                   family gatherings, and large-scale events.

                    {/* We believe food is not just a necessity—it’s an experience. From fresh ingredients and live counters to customized menus
                    and elegant presentation, we ensure every event becomes truly memorable. */}
                    </div>
                  </div>

                  {/* Fancy Boxes */}
                  <div className="fancy-box-wrapper">

                    <div className="fancy-box">
                      <div className="item">
                        <img
                          src="/assets/img/icon/aboutIcon1_1.svg"
                          alt="icon"
                        />
                      </div>
                      <div className="item">
                        <h6>super quality food</h6>
                        <p>Served our Testy Food & good food by friendly</p>
                      </div>
                    </div>

                    <div className="fancy-box">
                      <div className="item">
                        <img
                          src="/assets/img/icon/aboutIcon1_2.svg"
                          alt="icon"
                        />
                      </div>
                      <div className="item">
                        <h6>Qualified Chef</h6>
                        <p>Quality Food, Friendly Service</p>
                      </div>
                    </div>

                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        {/* Marquee */}
        <div className="marquee-wrapper style-1 text-slider section-padding pt-0">
          <div className="marquee-inner to-left">
            <ul className="marqee-list d-flex">
              <li className="marquee-item style1">
                <span className="text-slider"></span>
                <span className="text-slider text-style">PREMIUM CATERING EXPERIENCE</span>
                <span className="text-slider"></span>
                <span className="text-slider text-style">LIVE FOOD COUNTERS</span>
                <span className="text-slider"></span>
                <span className="text-slider text-style">CUSTOMIZED EVENT MENUS</span>
                <span className="text-slider"></span>
                <span className="text-slider text-style">ROYAL FOOD PRESENTATION</span>
                <span className="text-slider"></span>
                <span className="text-slider text-style">WEDDINGS & AUSPICIOUS EVENTS</span>
                <span className="text-slider"></span>
                <span className="text-slider text-style">FRESH INGREDIENTS, FLAWLESS TASTE</span>
                <span className="text-slider"></span>
                <span className="text-slider text-style">ELEGANT BUFFET & SERVICE</span>
              </li>
            </ul>
          </div>
        </div>

      </section>
      {/* About Us Section End */}
    </>
  );
};

export default AboutUsSection;
